import React, { useEffect, useState } from "react";
import "./Login.css";
import { Box, Input, Grid2, InputLabel, Button, Icon } from  "@mui/material"
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/11462643.jpg"
import { useDispatch } from "react-redux";
import { loginUser } from "../../features/login/loginAction";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
  const [formValues, setFormValues] = useState({username: "", password: ""});
  const [passwordError, setPasswordError] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Save token from query parameters to localStorage
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");

    if (token) {
      localStorage.setItem("token", token);
      toast.success('Login successfully!');
      navigate("/dashboard", { replace: true });
    } else {
      const isAuthenticated = !!localStorage.getItem("token");
      if (isAuthenticated) {
        navigate("/dashboard", { replace: true });
      }
    }
  }, [navigate]);

  const handleChange = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  }

  useEffect(() => {
        const isAuthenticated = !!localStorage.getItem("token");
        if (isAuthenticated) {
            navigate("/dashboard", { replace: true });
        }
 }, [navigate]);


  const handleLogin = async (e) => {
    e.preventDefault();
    const { username, password } = formValues;    
    const loginData = { password, email: username };

    try {
      dispatch(loginUser(loginData)).then((res) => {
      console.log('res :', res);
        if (res?.payload?.token) {
          localStorage.setItem('token', res?.payload?.token);
          toast.success('Login successfully!');
          navigate('/dashboard', { replace: true });
          return;
        } 
        if (res?.payload?.status === 400) {
          document.getElementById('reset-password-error').innerHTML = `<div class="errorMsg">${res?.data?.message}</div>`;
          document.getElementById('reset-password-error').style.display = 'block';
          document.getElementById('loginPasswordBtn').setAttribute("disabled", "disabled");
          return;
        } else {
          document.getElementById('reset-password-error').innerHTML = `<div class="errorMsg">${res?.error?.message}</div>`;
          document.getElementById('reset-password-error').style.display = 'block';
          document.getElementById('loginPasswordBtn').setAttribute("disabled", "disabled");
        }
      })
    } 
    catch (error) {
      console.log('Error -', error.message);
    }
  }

  const handleEmailChange = (event) => {
    let inputValue = event.target.value;
    const isValidEmail = (email) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(email.toLowerCase());
    const isMobileNumber = (str) => /^\d{10}$/.test(str);
    const containsOnlyNumbers = (str) => /^\d+$/.test(str);
    let errMsg = "Enter Valid Credentials";
    let emailValid = true;

    handleChange('username', inputValue);
    handleActiveLoginButton(inputValue, formValues.password);
    if (!isValidEmail(inputValue)) {// check if we want this function
      focusTextField("loginEmail");
      errMsg = "Enter Valid Credentials";
      emailValid = false;
    }

    if (
      (containsOnlyNumbers(inputValue) && !isMobileNumber(inputValue)) ||
      (!containsOnlyNumbers(inputValue) && !isValidEmail(inputValue))
    ) {
      errMsg = "Enter Valid Credentials";
      emailValid = false;
    }

    if (!emailValid) {
      document.getElementById('reset-password-error').innerHTML = `<div class="errorMsg">${errMsg}</div>`;
      document.getElementById('reset-password-error').style.display = 'block';
      document.getElementById('loginPasswordBtn').setAttribute("disabled", "disabled");
    } else {
      document.getElementById('reset-password-error').style.display = 'none';
      document.getElementById('loginPasswordBtn').removeAttribute("disabled");
    }

  };

  const handlePasswordChange = (event) => {
    let password = event.target.value;
    const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z]).{8,}$/;
    let errMsg = "Enter min 8 letters, with at least a symbol, lower case letters and a number";
    const captchaContainer = document.getElementById("captchaContainer");
    const loginError = document.getElementById("login-error");
    const loginButton = document.getElementById("login-button");
    handleChange('password', password);
    handleActiveLoginButton(formValues.username, password);

    let passValid = true;
    if (!regex.test(event.target.value)) {
      errMsg = "Enter min 8 letters, with at least a symbol, lower case letters and a number";
      passValid = false;
    }
    
    if (!passValid) {
      document.getElementById('reset-password-error').innerHTML = `<div class="errorMsg">${errMsg}</div>`;
      document.getElementById('reset-password-error').style.display = 'block';
      document.getElementById('loginPasswordBtn').setAttribute("disabled", "disabled");
    } else {
      document.getElementById('reset-password-error').style.display = 'none';
      document.getElementById('loginPasswordBtn').removeAttribute("disabled");
    }

      if (!regex.test(password)) {
        setPasswordError(errMsg);
        setIsButtonDisabled(true);
      } else {
        if (captchaContainer) {
          captchaContainer.style.display = "block";
        }
        setPasswordError("");
        setIsButtonDisabled(false);
      }
  
    if (loginError) {
      if (passwordError) {
        loginError.innerHTML = `<div class="errortext">${passwordError}</div>`;
        loginError.style.display = "block";
      } else {
        loginError.style.display = "none";
      }
    }
  
    if (loginButton) {
      if (isButtonDisabled) {
        loginButton.setAttribute("disabled", "disabled");
      } else {
        loginButton.removeAttribute("disabled");
      }
    }
  };

  const focusTextField = (fieldId) => { // check if we want it.
    const field = document.getElementById(fieldId);
    if (field) {
      field.focus();
    }
  };

  const togglePasswordVisibility = (inputId, iconId) => {
    setShowPassword((prev) => !prev);
    const passwordInput = document.getElementById(inputId);
    const icon = document.getElementById(iconId);
  if (passwordInput) {
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        return icon?.classList?.replace("fa-eye-slash", "fa-eye");
      } else {
        passwordInput.type = "password";
        return icon?.classList?.replace("fa-eye", "fa-eye-slash");
      }
    } else {
      console.error(`Input element with id "${inputId}" not found.`);
    }
  };

  const preventSpaceKey = (event) => {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  };

  const handleActiveLoginButton = (username, password, recaptchaToken) => {
    const isValid = username && password && recaptchaToken;
    setIsButtonDisabled(!isValid);
  };

    return (
       <>
        <Grid2 className="login-parent-div">
          <Grid2 className="login-child-div">
            <Box component="img" id="login-img-learn" className="login-logo" src={logo} alt="" />
          </Grid2>
          <Grid2 className="login-right-side-box">
          <Box className="login-title" style={{ color: "#0c3450" }}>Login</Box>
          <Box className="form-group error-msg" id="reset-password-error"></Box>
          <Box component="form" id="form-login" name="loginForm" className="form-horizontal" onSubmit={handleLogin} method="post">
            <Box>
              <Box className="mdc-text-field mdc-text-field--outlined email-field">
                <Box className="mdc-notched-outline__notch">
                  <InputLabel style={{color: "#0c3450"}} className="mdc-text-field__label" htmlFor="loginEmail"
                    >Email</InputLabel>
                </Box>
                <Input type="text" value={formValues.username} className="input-box required_text" id="loginEmail" autoComplete="off" placeholder="Email" onChange={handleEmailChange} onKeyDown={preventSpaceKey} />
              </Box>
              <Box className="help-block with-errors"></Box>
            </Box>
            <Box style={{position: 'relative'}}>
              <Box className="mdc-text-field mdc-text-field--outlined removeTopGap">
                <InputLabel style={{color: "#0c3450"}} className="mdc-text-field__label" htmlFor="loginPassword">Password</InputLabel>
                <Input
                  type={showPassword ? "text" : "password"}
                  value={formValues.password}
                  className="input-box required_text"
                  id="loginPassword"
                  autoComplete="off"
                  placeholder="Password"
                  onChange={handlePasswordChange}
                  onKeyDown={preventSpaceKey}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  className="toggle-password-icon"
                  id="toggleLoginPassword"
                  onClick={() => togglePasswordVisibility('loginPassword', 'toggleLoginPassword')}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(0%) !important",
                    width: '16px',
                    cursor: "pointer",
                  }}
                />
                <Box className="mdc-notched-outline">
                  <Box className="mdc-notched-outline__leading"></Box>
                  <Box className="mdc-notched-outline__trailing"></Box>
                </Box>
              </Box>
              <Box className="help-block with-errors"></Box>
            </Box>
              <Box className="parent-login-button-div">
               <Button
                    type="submit"
                    id="loginPasswordBtn"
                    className={`login-new-btn ${isButtonDisabled ? 'disabled-btn' : ''}`}
                    style={{backgroundColor: "#0c3450", color: "#fff"}}
                >
                Login
               </Button>
              </Box>
          </Box>
          </Grid2>
        </Grid2>
       </>
    );
};

export default Login;
